import { create } from "zustand"
import { devtools } from "zustand/middleware"

type CustomHistoryDialogStore = {
  isOpen: boolean
  setIsOpen: (isOpen: boolean) => void
  idfPlayer: number | null
  setIdfPlayer: (idfPlayer: number | null) => void
}

export const createCustomHistoryDialogStore = create<CustomHistoryDialogStore>()(
  devtools(
    (set) => ({
      isOpen: false,
      setIsOpen: (isOpen: boolean) => set({ isOpen }, undefined, "setIsOpen"),
      idfPlayer: null,
      setIdfPlayer: (idfPlayer: number | null) => set({ idfPlayer }, undefined, "setIdfPlayer"),
    }),
    { store: "customHistoryDialog", enabled: process.env.NODE_ENV !== "production" },
  ),
)
